import { layers, layersWMS } from "./layers";
import { updateAllLayers } from "./update";

const layerController = {
    /**
     * Initializes layers
     * @param {"gna" | "altre-banche-dati" | "iccd" | "concessione"} mapType
     */
    init: (mapType) => {
        // setup map types
        const gna = document.querySelector("#gna-dati-map-type-radio");
        const concessione = document.querySelector(
            "#gna-concessione-map-type-radio"
        );
        const iccd = document.querySelector("#gna-iccd-map-type-radio");
        const altreBancheDati = document.querySelector(
            "#gna-altre-banche-dati-map-type-radio"
        );

        gna.checked = false;
        concessione.checked = false;
        iccd.checked = false;
        altreBancheDati.checked = false;

        switch (mapType) {
            case "gna":
                gna.checked = true;
                break;
            case "altre-banche-dati":
                altreBancheDati.checked = true;
                break;
            case "iccd":
                iccd.checked = true;
                break;
            case "concessione":
                concessione.checked = true;
                break;
            default:
                break;
        }

        gna.addEventListener("click", (e) => {
            if (e.target.checked) {
                layerController.selectMap("gna");
            }
        });
        concessione.addEventListener("click", (e) => {
            if (e.target.checked) {
                layerController.selectMap("concessione");
            }
        });
        iccd.addEventListener("click", (e) => {
            if (e.target.checked) {
                layerController.selectMap("iccd");
            }
        });
        altreBancheDati.addEventListener("click", (e) => {
            if (e.target.checked) {
                layerController.selectMap("altre-banche-dati");
            }
        });

        // setup layers
        const censimento = document.querySelector(
            "#gna-dati-checkbox-censimento"
        );
        const tess = document.querySelector("#gna-dati-checkbox-tess");

        censimento.addEventListener("click", (e) => {
            layers.AltreBancheDati.censimento.setVisible(e.target.checked);
            layersWMS.AltreBancheDati.censimento.setVisible(e.target.checked);
        });

        tess.addEventListener("click", (e) => {
            layers.AltreBancheDati.tess.setVisible(e.target.checked);
            layersWMS.AltreBancheDati.tess.setVisible(e.target.checked);
        });

        // data gna checkbox on other layers than gna
        const dataGNAICCD = document.querySelector("#gna-dati-checkbox-iccd");
        const dataGNAConcessione = document.querySelector(
            "#gna-dati-checkbox-concessione"
        );
        const dataGNAALtreBancheDati = document.querySelector(
            "#gna-dati-checkbox-altre-banche-dati"
        );

        dataGNAICCD.addEventListener("click", (e) => {
            layerController.setGNALayer(e.target.checked);
        });
        dataGNAConcessione.addEventListener("click", (e) => {
            layerController.setGNALayer(e.target.checked);
        });
        dataGNAALtreBancheDati.addEventListener("click", (e) => {
            layerController.setGNALayer(e.target.checked);
        });

        layerController.selectMap(mapType);
    },

    /**
     *
     * @type {"gna" | "altre-banche-dati" | "iccd" | "concessione"}
     */
    currentMap: "gna",

    /**
     *
     * @param {"gna" | "altre-banche-dati" | "iccd" | "concessione"} mapName
     */
    selectMap: (mapName) => {
        switch (mapName) {
            case "gna":
                selectGNAMap();
                break;
            case "concessione":
                setMaxZoomGNAWMSLayer(22);
                selectConcessioneMap();
                break;
            case "iccd":
                setMaxZoomGNAWMSLayer(22);
                selectICCDMap();
                break;
            case "altre-banche-dati":
                setMaxZoomGNAWMSLayer(22);
                selectAltreBancheDatiMap();
                break;
            default:
                return;
        }

        layerController.currentMap = mapName;
    },

    hideAll: () => {
        layers.GNA.punti.setVisible(false);
        layers.GNA.linee.setVisible(false);
        // layers.GNA.poligoni.setVisible(false);
        layers.GNA.poligoni2.setVisible(false);
        layers.GNA.progetti.setVisible(false);
        layers.GNA.ricostruitiLinee.setVisible(false);
        layers.GNA.ricostruitiPoligoni.setVisible(false);
        layers.Concessione.setVisible(false);
        layers.ICCD.setVisible(false);
        layers.AltreBancheDati.censimento.setVisible(false);
        layers.AltreBancheDati.tess.setVisible(false);

        // HIDE WMS LAYERS
        layersWMS.GNA.multiline.setVisible(false);
        layersWMS.GNA.multipoint.setVisible(false);
        layersWMS.GNA.multipolygon.setVisible(false);
        layersWMS.ICCD.setVisible(false);
        layersWMS.AltreBancheDati.censimento.setVisible(false);
        layersWMS.AltreBancheDati.tess.setVisible(false);
    },

    setGNALayer: (visible) => {
        layersWMS.GNA.multipoint.setVisible(visible);
        layersWMS.GNA.multiline.setVisible(visible);
        layersWMS.GNA.multipolygon.setVisible(visible);
    },
};

const isGNALayerEnabled = (currentMap) => {
    const el = document.querySelector(`#gna-dati-checkbox-${currentMap}`);
    return el && el.checked;
};

const updateGNALayer = (currentMap) => {
    if (isGNALayerEnabled(currentMap)) {
        layersWMS.GNA.multipoint.setVisible(true);
        layersWMS.GNA.multiline.setVisible(true);
        layersWMS.GNA.multipolygon.setVisible(true);
    } else {
        layersWMS.GNA.multipoint.setVisible(false);
        layersWMS.GNA.multiline.setVisible(false);
        layersWMS.GNA.multipolygon.setVisible(false);
    }
};

const selectGNAMap = () => {
    layerController.hideAll();
    setMaxZoomGNAWMSLayer(9);

    layersWMS.GNA.multiline.setVisible(true);
    layersWMS.GNA.multipoint.setVisible(true);
    layersWMS.GNA.multipolygon.setVisible(true);

    layers.GNA.punti.setVisible(true);
    layers.GNA.linee.setVisible(true);
    // layers.GNA.poligoni.setVisible(true);
    layers.GNA.poligoni2.setVisible(true);
    layers.GNA.progetti.setVisible(true);
    layers.GNA.ricostruitiLinee.setVisible(true);
    layers.GNA.ricostruitiPoligoni.setVisible(true);
};

const setMaxZoomGNAWMSLayer = (zoom) => {
    layersWMS.GNA.multiline.setMaxZoom(zoom);
    layersWMS.GNA.multipoint.setMaxZoom(zoom);
    layersWMS.GNA.multipolygon.setMaxZoom(zoom);
};

const selectConcessioneMap = () => {
    // layerController.hideAll();

    layers.GNA.punti.setVisible(false);
    layers.GNA.linee.setVisible(false);
    // layers.GNA.poligoni.setVisible(false);
    layers.GNA.poligoni2.setVisible(false);
    layers.GNA.progetti.setVisible(false);
    layers.GNA.ricostruitiLinee.setVisible(false);
    layers.GNA.ricostruitiPoligoni.setVisible(false);
    layers.ICCD.setVisible(false);
    layers.AltreBancheDati.censimento.setVisible(false);
    layers.AltreBancheDati.tess.setVisible(false);

    // HIDE WMS LAYERS
    // layersWMS.GNA.multiline.setVisible(false);
    // layersWMS.GNA.multipoint.setVisible(false);
    // layersWMS.GNA.multipolygon.setVisible(false);
    layersWMS.ICCD.setVisible(false);
    layersWMS.AltreBancheDati.censimento.setVisible(false);
    layersWMS.AltreBancheDati.tess.setVisible(false);

    layers.Concessione.setVisible(true);
    updateGNALayer("concessione");
};

const selectICCDMap = () => {
    // layerController.hideAll();

    layers.GNA.punti.setVisible(false);
    layers.GNA.linee.setVisible(false);
    // layers.GNA.poligoni.setVisible(false);
    layers.GNA.poligoni2.setVisible(false);
    layers.GNA.progetti.setVisible(false);
    layers.GNA.ricostruitiLinee.setVisible(false);
    layers.GNA.ricostruitiPoligoni.setVisible(false);
    layers.Concessione.setVisible(false);
    // layers.ICCD.setVisible(false);
    layers.AltreBancheDati.censimento.setVisible(false);
    layers.AltreBancheDati.tess.setVisible(false);

    // HIDE WMS LAYERS
    // layersWMS.GNA.multiline.setVisible(false);
    // layersWMS.GNA.multipoint.setVisible(false);
    // layersWMS.GNA.multipolygon.setVisible(false);
    layersWMS.AltreBancheDati.censimento.setVisible(false);
    layersWMS.AltreBancheDati.tess.setVisible(false);

    layersWMS.ICCD.setVisible(true);
    layers.ICCD.setVisible(true);
    updateGNALayer("iccd");
};

const selectAltreBancheDatiMap = () => {
    // layerController.hideAll();

    layers.GNA.punti.setVisible(false);
    layers.GNA.linee.setVisible(false);
    // layers.GNA.poligoni.setVisible(false);
    layers.GNA.poligoni2.setVisible(false);
    layers.GNA.progetti.setVisible(false);
    layers.GNA.ricostruitiLinee.setVisible(false);
    layers.GNA.ricostruitiPoligoni.setVisible(false);
    layers.Concessione.setVisible(false);
    layers.ICCD.setVisible(false);

    // HIDE WMS LAYERS
    // layersWMS.GNA.multiline.setVisible(false);
    // layersWMS.GNA.multipoint.setVisible(false);
    // layersWMS.GNA.multipolygon.setVisible(false);
    layersWMS.ICCD.setVisible(false);

    layersWMS.AltreBancheDati.censimento.setVisible(true);
    layersWMS.AltreBancheDati.tess.setVisible(true);
    layers.AltreBancheDati.censimento.setVisible(true);
    layers.AltreBancheDati.tess.setVisible(true);
    updateGNALayer("altre-banche-dati");
};

export { layerController };
